import Axios from "axios";
import {
    SET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST, 
    UNSET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST
} from "@/store/mutation-types";
import {
    getAllowanceDeductionBreakupReport,
} from "@/store/api";

const state = {
    getAllowanceDeductionBreakupReport: [],
};

const getters = {
    getAllowanceDeductionBreakupReport(state) {
        return state.getAllowanceDeductionBreakupReport;
    },
};

const mutations = {
    [SET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST](state, data) {
        state.getAllowanceDeductionBreakupReport = data;
    },
    [UNSET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST](state) {
        state.getAllowanceDeductionBreakupReport = [];
    },
};

const actions = {

    getAllowanceDeductionBreakupReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getAllowanceDeductionBreakupReport}`, { params: data })
                .then((response) => {
                    commit(SET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_ALLOWANCE_DEDUCTION_BREAKUP_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};